import styled from 'styled-components';
import Slider from '@material-ui/lab/Slider';

export const Wrap = styled.div`
  display: flex;
  flex-direction: column;
  padding-bottom: 16px;
`;

export const Name = styled.div`
  padding-bottom: 4px;
  ${({ theme }) => theme.textStyles.paragraph01global02};
`;

export const SliderWrap = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const Input = styled.input`
  width: 48px;
  height: 20px;
  margin-left: 8px;
`;

export const SliderStyled = styled(Slider).attrs({
  classes: {
    track: 'track',
    thumb: 'thumb',
  },
})`
  .thumb {
    background-color: ${({ theme }) => theme.palette.global01};
  }

  .track {
    background-color: ${({ theme }) => theme.palette.global01};
  }
`;



// WEBPACK FOOTER //
// /opt/build/repo/src/app/components/Slider/Slider.styled.js